import React, { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import { useNavigate } from "react-router-dom";
import Timer from "./Timer";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import EmptyHeader from "./EmptyHeader";
import { isDevelopmentMode } from "../services/base";
import { checkOtpCode } from "../services/auth";
import {
  getUserOS,
  getUserBrowser,
  getDeviceModel,
} from "../utils/checkUserOSAndBrowser";
import { getFirebaseToken } from "../notifications/firebase";
let FirstTime = true;
export default function OtpVerify({ destination, isLogin }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [choose] = useState(location.state.activeMethod);
  const [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [flag, setflag] = useState(false);
  const [firebaseToken, setFirebaseToken] = useState(null);

  const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
  function handleChange(code) {
    setOtp(p2e(code));
    if (code.length === 6) {
      if (FirstTime) {
        FirstTime = false;
        handelSubmit(code);
      }
    }
  }

  try {
    if (destination) {
    } else {
      destination = location.state.destination;

      isLogin = location.state.isLogin;
    }
  } catch {}

  function handelSubmit(code) {
    setIsLoading(true);

    const params = { verify_code: code };
    params.identifier = destination;

    if (!otp) {
      toast.error("لطفا تمام موارد را به درستی تکمیل نمایید");
      setIsLoading(false);
      return;
    }
    if (isDevelopmentMode()) {
      params.os = getUserOS().split("none").join("").trim();
      params.brand = getUserBrowser();
      const model = getDeviceModel();
      params.device_model =
        !model || model === "null" || model.indexOf("none") >= 0 ? null : model;
    }
    checkOtpCode(params)
      .then((res) => {
        if (res.status == 200) {
          if (isLogin || isDevelopmentMode()) {
            localStorage.setItem("token", res.data?.data?.access);
            localStorage.setItem("refresh", res.data?.data?.refresh);
            localStorage.setItem("device_id", res.data?.data?.device_id);
            toast.success("با موفقیت وارد شدید.");
            navigate("/", { state: { destination: destination } });
          } else {
            navigate("/sendinfo", {
              state: { destination: destination, otp: code },
            });
          }
        } else {
          toast.error(" کد وارد شده صحیح نمیباشد");
          setIsLoading(false);
        }
      })
      .catch((e) => {
        setIsLoading(false);
      });
  }
  useEffect(() => {
    async function requestFireBase() {
      const token = await getFirebaseToken();
      setFirebaseToken(token);
    }
    if ("OTPCredential" in window) {
      window.addEventListener("DOMContentLoaded", (e) => {
        const input = document.getElementById("otp-input");
        if (!input) return;
        const ac = new AbortController();
        const form = input.closest("form");
        if (form) {
          form.addEventListener("submit", (e) => {
            ac.abort();
          });
        }
        navigator.credentials
          .get({
            otp: { transport: ["sms"] },
            signal: ac.signal,
          })
          .then((otp) => {
            setOtp(otp.code);
            if (form) handelSubmit(otp.code);
          })
          .catch((err) => {
            toast.error(err.message);
          });
      });
    }
    requestFireBase();
  }, []);
  return (
    <>
      <EmptyHeader />
      <form className="text-center">
        <h3 className="title-for-login title-for-login-desktop">
          ورود به حساب کاربری
        </h3>
        <div className="container">
          <div className="row justify-content-center h-100 section-padding align-items-center">
            <div className="col-xl-6 col-md-8">
              <div className="row">
                <div className="col-6 text-end">
                  <button
                    type="button"
                    id={"mobile"}
                    name="mobile"
                    className={
                      "btn-choose btn-330" +
                      (choose === "mobile" ? "" : " not-active-login")
                    }
                  >
                    از طریق موبایل
                  </button>
                </div>

                <div className="col-6 text-end">
                  <button
                    type="button"
                    id={"email"}
                    name="email"
                    className={
                      "btn-choose btn-331" +
                      (choose === "email" ? "" : " not-active-login")
                    }
                  >
                    از طریق ایمیل
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="authincation section-padding">
          <div className="container h-100">
            <div className="row justify-content-center h-100 align-items-center">
              <div className="col-xl-6 col-md-8">
                <div className="mini-logo text-center my-2"></div>
                <div className="auth-form custom-shadow">
                  <form className={"text-end"}>
                    <OtpInput
                      id="otp-input"
                      value={otp}
                      type={"tel"}
                      onChange={handleChange}
                      numInputs={6}
                      separator={<span> </span>}
                      containerStyle="div-ltr verify-code"
                      inputStyle="otp"
                    />

                    <div className="text-center pt-3 w-100">
                      <button
                        disabled={flag}
                        type="button"
                        className="btn w-100 btn-submit btn-block spinner-button py-2"
                        id="submit"
                        data-loading-text="<i className='fas fa-spinner fa-pulse'></i>"
                        onClick={() => handelSubmit(otp)}
                      >
                        {isLoading ? (
                          <div>
                            <img
                              src={"./loading.svg"}
                              alt={""}
                              className={"w-loading"}
                            />
                          </div>
                        ) : (
                          <span>ورود</span>
                        )}
                      </button>
                    </div>
                    <div className="pt-3 info-text">
                      <p className="text-end text-medium d-inline-flex pe-2">
                        زمان باقی مانده
                      </p>

                      <p className=" mymedium d-inline-flex ps-2 pe-2">
                        <span className="mymedium pe-2">
                          <Timer des={destination} />
                        </span>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}
